function isString (value) {
  return typeof value === 'string'
}

module.exports = isString



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-faux-dom/lib/utils/isString.js
// module id = 698
// module chunks = 0